module.exports = __webpack_public_path__ + "img/ean-generator.7b4caea7.svg";